import { render, staticRenderFns } from "./loginmiddle.vue?vue&type=template&id=6a716ce6&scoped=true&lang=pug"
import script from "./loginmiddle.vue?vue&type=script&lang=js"
export * from "./loginmiddle.vue?vue&type=script&lang=js"
import style0 from "./loginmiddle.vue?vue&type=style&index=0&id=6a716ce6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a716ce6",
  null
  
)

export default component.exports